import React from "react";
import SelectSystem from "./select-system";
import SendEmailCode from "./send-email-code";
import {useAppSelector} from "../DAL/store";
import Preloader from "../../../ui/svg/common/preloader";
import Category from "./category";
import ProductPriceFormat from "../../products/product-price/product-price-format";

/**
 * System Builder Options
 */
const SystemBuilderOptions = () => {

    const UserState_Cost = useAppSelector((store) => store.UserState_Cost);
    const UserState_CostLoading = useAppSelector((store) => store.UserState_CostLoading);
    const UserState_CategoriesIsMandatory = useAppSelector((store) => store.UserState_CategoriesIsMandatory);
    const ProductList = useAppSelector((store) => store.ProductList);
    const UserState_SoftwareWasChosen = useAppSelector((store) => store.UserState_SoftwareWasChosen);
    const CurrentCategories = UserState_CategoriesIsMandatory.filter(category => ( category.isHidden === false || !UserState_SoftwareWasChosen))
        .sort((a,b) => a.categoryOrder - b.categoryOrder);

    return (
        <div className="bg-white border rounded py-6 md:px-6 text-gray-700 flex-1 md:w-screen px-4 md:p-0  lg:mr-6 lg:w-1/2 xl:width-70p">
            <SelectSystem />
            <ul>
                {CurrentCategories.map((category,index) => {
                    let categoryProducts = ProductList.filter(product => product.categoryID === category.categoryID);
                    if(categoryProducts.length > 0){

                        return <Category categoryId={category.categoryID}
                                         isVisible={!category.isHidden}
                                         isMandatory={category.isMandatory}
                                         products={categoryProducts}
                                         index={index + 2} key={index} />
                    }else{
                        return "";
                    }
                })}
            </ul>

            <div className="pt-8 text-xl w-full pb-6">
                <div className="">Total : {UserState_CostLoading ?
                    <div>
                        <Preloader width="25px" height="25px" color="#4f4f4f" />
                    </div>
                    :
                    <ProductPriceFormat price={ UserState_Cost } />
                }</div>
            </div>
            <div className="pt-2 w-full">
                <div id="sendMailSection" className="w-auto underline font-bold text-xl">Buy from your local dealer</div>
                <SendEmailCode />
            </div>


        </div>

    );
};

export default SystemBuilderOptions;
